export default "__VITE_ASSET__CLnUcmdf__"